import { render, staticRenderFns } from "./OrderKeyNull.vue?vue&type=template&id=47b489dd&"
import script from "./OrderKeyNull.vue?vue&type=script&lang=js&"
export * from "./OrderKeyNull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports